import { useAuthStore } from "@/stores/auth";

const TIER_ORDER: Record<string, number> = {
  free: 0,
  explorer: 1,
  builder: 2,
  scale: 3,
  enterprise: 4,
  // Legacy mappings
  starter: 1,
  pro: 2,
};

const FEATURE_TIERS: Record<string, string> = {
  // Free (v1.77.0): upload → extraction → HITL review → basic equipment
  // totals on one festival, 10 riders / month. Exports and /optimize stay
  // Explorer+.
  upload_rider: "free",
  review_hitl: "free",
  equipment_basic: "free",
  export_csv: "explorer",
  run_optimization: "explorer",
  auto_assign: "builder",
  changeover_planner: "builder",
  production_plan: "builder",
  venue_search: "builder",
  conflict_detector: "builder",
  equipment_per_day: "builder",
  export_full: "builder",
  team_management: "builder",
  hospitality_extraction: "builder",
  crew_calculator: "scale",
  email_draft: "scale",
  logistics_intelligence: "scale",
  hotel_management: "scale",
  transport_timeline: "scale",
  production_timeline: "scale",
  api_keys: "enterprise",
};

export function usePermission(feature: string) {
  const user = useAuthStore((s) => s.user);
  const currentTier = user?.effective_tier ?? user?.subscription_status ?? "free";
  const requiredTier = FEATURE_TIERS[feature] ?? "free";
  const allowed = (TIER_ORDER[currentTier] ?? 0) >= (TIER_ORDER[requiredTier] ?? 0);

  return { allowed, requiredTier, currentTier };
}
